import React from "react";
import { Link } from "react-router-dom";

function LiveGames() {
    return (
       
        <section className="match-content">
            {/* <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}> CASINO GAMES</div> */}
            
            <div className="live-games-heading-block" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                <span className="live-games-heading-txt" style={{color : 'white'}}>Live Casino</span>
            </div>
            <div className="padding-lr-15 row">
                {/* <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/BBB">
                        <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div>
                        <img src="/assets/images/ballbyball.jpg" className="casino-img" alt="" style={{height:"170px"}}/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>Ball By Ball</span>
                    </Link>
                </div> */}
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/TPT20">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/-1.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text">Teenpatti T20</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/TPOdi">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/teen.jpg" className="casino-img" alt=""/>
                        <span className="casino_img_text">Teenpatti ODI</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/DTT20">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/-1011.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text">Dragon Tiger</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/L7A">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/-145.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text">Lucky 7 A</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/AB2">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/-1021.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text">Andar Bahar 2</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/AAA">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/-1016.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>AAA</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/AAA_v2">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/aaa.jpg" className="casino-img" alt="" style={{height:"170px"}}/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>AAA Ver. 2</span>
                    </Link>
                </div>
                {/* <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/WM">                        
                        <img src="/assets/images/-153.webp" className="casino-img" alt=""/>
                        <span className="casino_img_text">Worli Matka</span>
                    </Link>
                </div> */}
                {/* <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                        <div className="blink">
                            <span className="blink-txt">Comming Soon</span>
                        </div>
                        <img src="/assets/images/superover2.jpg" className="casino-img" alt="" style={{height:"170px"}}/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>Super Over 2</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                        <div className="blink">
                            <span className="blink-txt">Comming Soon</span>
                        </div>
                        <img src="/assets/images/btable.jpg" className="casino-img" alt="" style={{height:"170px"}}/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>Bollywood Casino</span>
                    </Link>
                </div>
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="" onClick={(e) => {e.preventDefault();alert('Coming Soon');}}>
                        <div className="blink">
                            <span className="blink-txt">Comming Soon</span>
                        </div>
                        <img src="/assets/images/card32.jpg" className="casino-img" alt="" style={{height:"170px"}}/>
                        <span className="casino_img_text" style={{fontSize:'12px'}}>32 Cards A</span>
                    </Link>
                </div> */}
                
            </div>

            <div className="live-games-heading-block">
                <span className="live-games-heading-txt">Matka</span>
            </div>
            <div className="padding-lr-15 row">
                {/* <div className="padding-lr-0 col-6 col-md-2">
                    <a href="#" onClick={() => alert('Comming Soon')}>
                        <img src="/assets/images/v_ab.jpg" className="casino-img" alt=""/>
                    </a>
                </div> */}
                <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Dashboard/Matka">
                        {/* <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div> */}
                        <img src="/assets/images/matka.png" className="casino-img" alt=""/>
                    </Link>
                </div>
                {/* <div className="padding-lr-0 col-6 col-md-2">
                    <Link to="/Aviator">
                        <div className="blink">
                            <span className="blink-txt">New Launch</span>
                        </div>
                        <img src="/assets/images/aviator.jpg" className="casino-img" alt=""/>
                    </Link>
                </div> */}
            </div>
        </section>
       
    )
}

export default LiveGames;